// Polyfill for URL.parse (not supported in older Safari versions)
// This fixes pdf.js error: "URL.parse is not a function"
if (typeof URL.parse !== 'function') {
  URL.parse = function(url, base) {
    try {
      return new URL(url, base);
    } catch (e) {
      return null;
    }
  };
}